import { Controller } from "@hotwired/stimulus";
import confetti from "canvas-confetti";

// Connects to data-controller="referral-success"
//
// Shown in the bottom sheet after a referral is sent: the server replaces the
// wizard with the success screen (targeting sheet_frame so the modal keeps the
// sheet open). Fires a celebratory confetti burst, holds the screen briefly,
// then closes the sheet (the user can also dismiss it sooner via the Close
// button / swipe / backdrop / Escape).
export default class extends Controller {
  static values = { delay: { type: Number, default: 2500 } };

  declare delayValue: number;
  declare timeout: ReturnType<typeof setTimeout> | undefined;

  connect() {
    this.celebrate();
    this.timeout = setTimeout(() => this.close(), this.delayValue);
  }

  disconnect() {
    clearTimeout(this.timeout);
  }

  private celebrate() {
    const defaults = {
      zIndex: 56,
      disableForReducedMotion: true,
      spread: 90,
      startVelocity: 45,
      particleCount: 70,
      origin: { y: 0.6 },
    };
    confetti({ ...defaults, angle: 60, origin: { x: 0, y: 0.7 } });
    confetti({ ...defaults, angle: 120, origin: { x: 1, y: 0.7 } });
  }

  private close() {
    const host = document.querySelector<HTMLElement>(
      '[data-modal-frame-target-value="sheet_frame"]',
    );
    if (!host) return;
    const modal = this.application.getControllerForElementAndIdentifier(
      host,
      "modal",
    ) as { close?: () => void } | null;
    modal?.close?.();
  }
}
